export default {
  appName: 'Pulsebeat.app',
};
